import React from 'react'
import { useLocation, useParams, Redirect } from '@fs/zion-router'
import { useGroupsContext } from '@fs/zion-tree-groups'

// Suppose to be a interim solution until we can restructure zion packages to remove circular deps issues
export default function TreeIdToGroupId() {
  const { treeId } = useParams()
  const { groups } = useGroupsContext()
  const location = useLocation()
  const groupId = groups?.find((group) => group.treeIds?.[0] === treeId)?.id
  if (groupId) return <Redirect to={`/family/${groupId}/details${location.search || ''}`} />
  return <Redirect to="/family" />
}
